import Api from './api';

export const getQueue = async (params = {}) => {
  let data = [];
  const queryParams = new URLSearchParams();

  // Paginação
  if (params.offset !== undefined) queryParams.append('offset', params.offset);
  if (params.limit !== undefined) queryParams.append('limit', params.limit);

  // Filtros
  if (params.itemType) queryParams.append('itemType', params.itemType);
  if (params.priorityId) queryParams.append('priorityId', params.priorityId);
  if (params.categoryId != null) queryParams.append('categoryId', params.categoryId);
  if (params.categoryName) queryParams.append('categoryName', params.categoryName);
  if (params.organizationId) queryParams.append('organizationId', params.organizationId);
  if (params.statusId) queryParams.append('statusId', params.statusId);
  if (params.statusName) queryParams.append('statusName', params.statusName);
  if (params.channelName) queryParams.append('channelName', params.channelName);
  if (params.messageProviderName) queryParams.append('messageProviderName', params.messageProviderName);
  if (params.urgencyGroup) queryParams.append('urgencyGroup', params.urgencyGroup);
  if (params.searchTerm) queryParams.append('searchTerm', params.searchTerm);

  // Ordenação
  if (params.sortBy) queryParams.append('sortBy', params.sortBy);
  if (params.sortDesc !== undefined) queryParams.append('sortDesc', params.sortDesc);

  const queryString = queryParams.toString();
  const url = `/agent-workspace/queue${queryString ? `?${queryString}` : ''}`;

  await Api.get(url)
    .then(result => {
      data = result.data;
    })
    .catch(err => {
      data = err;
    });
  return data;
};

export const getQueueFilters = async () => {
  let data = null;
  await Api.get('/agent-workspace/queue/filters')
    .then(result => {
      data = result.data;
    })
    .catch(err => {
      data = err;
    });
  return data;
};

export const getNextItem = async () => {
  let data = null;
  await Api.get('/agent-workspace/queue/next')
    .then(result => {
      data = result.data;
    })
    .catch(err => {
      data = err;
    });
  return data;
};

export const getMetrics = async () => {
  let data = null;
  await Api.get('/agent-workspace/metrics')
    .then(result => {
      data = result.data;
    })
    .catch(err => {
      data = err;
    });
  return data;
};

export const getPreferences = async () => {
  let data = null;
  await Api.get('/agent-workspace/preferences')
    .then(result => {
      data = result.data;
    })
    .catch(err => {
      data = err;
    });
  return data;
};

export const savePreferences = async (preferences) => {
  let data = null;
  await Api.put('/agent-workspace/preferences', preferences)
    .then(result => {
      data = result.data;
    })
    .catch(err => {
      data = err;
    });
  return data;
};

export const getStatus = async () => {
  let data = null;
  await Api.get('/agent-workspace/status')
    .then(result => {
      data = result.data;
    })
    .catch(err => {
      data = err;
    });
  return data;
};

export const updateStatus = async (statusId) => {
  let data = null;
  await Api.put(`/agent-workspace/status/${statusId}`)
    .then(result => {
      data = result.data;
    })
    .catch(err => {
      data = err;
    });
  return data;
};

export const pauseDistribution = async () => {
  let data = null;
  await Api.post('/agent-workspace/distribution/pause')
    .then(result => {
      data = result.data;
    })
    .catch(err => {
      data = err;
    });
  return data;
};

export const resumeDistribution = async () => {
  let data = null;
  await Api.post('/agent-workspace/distribution/resume')
    .then(result => {
      data = result.data;
    })
    .catch(err => {
      data = err;
    });
  return data;
};
